<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">生产日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.mh_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单号</label>
            <span class="weui-form-preview__value">{{initData.ma_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.ma_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造类型</label>
            <span class="weui-form-preview__value">{{initData.ma_kind}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单数量</label>
            <span class="weui-form-preview__value">{{initData.ma_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已领齐套数</label>
            <span class="weui-form-preview__value">{{initData.ma_setqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产出数量</label>
            <span class="weui-form-preview__value">{{initData.mh_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">qc检验数量</label>
            <span class="weui-form-preview__value">{{initData.qc_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良品数量</label>
            <span class="weui-form-preview__value">{{initData.qc_ngqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良品率%</label>
            <span class="weui-form-preview__value">{{initData.qc_ngrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">foqc待检数量</label>
            <span class="weui-form-preview__value">{{initData.foqc_djqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">foqc待入库数量</label>
            <span class="weui-form-preview__value">{{initData.foqc_dinqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工入库数量</label>
            <span class="weui-form-preview__value">{{initData.madeqty}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>